import React from 'react';

import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';

import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import './styles.scoped.css';
import { TablePagination } from '../../../components';

const columnClassName = 'align-middle text-nowrap';

const casColumns = [
  {
    Header: 'Branch',
    accessor: 'Branch',
    className: columnClassName,
  },
  {
    Header: 'LOB',
    accessor: 'LOB',
    className: columnClassName,
  },
  {
    Header: 'Customer Number',
    accessor: 'CUST_ID',
    className: columnClassName,
  },
  {
    Header: 'Customer Name',
    accessor: 'CUST_NAME',
    className: columnClassName,
  },
  {
    Header: 'Status',
    accessor: 'CUST_STATUS',
    className: columnClassName,
  },
  {
    Header: 'Phone',
    accessor: 'NUM_PHONE',
    className: columnClassName,
  },
  {
    Header: 'SPC',
    accessor: 'SPC',
    className: columnClassName,
  },
  {
    Header: 'Bill To #',
    accessor: 'Bill_To',
    className: columnClassName,
  },
  {
    Header: 'Bill To Name',
    accessor: 'Bill_To_Client',
    className: columnClassName,
  },
  {
    Header: 'Address Line 1',
    accessor: 'Address_Line_1',
    className: columnClassName,
  },
  {
    Header: 'Address Line 2',
    accessor: 'Address_Line_2',
    className: columnClassName,
  },
  {
    Header: 'City',
    accessor: 'CUST_CITY',
    className: columnClassName,
  },
  {
    Header: 'State',
    accessor: 'CUST_STATE',
    className: columnClassName,
  },
  {
    Header: 'ZIP',
    accessor: 'CUST_POSTCODE',
    className: columnClassName,
  },
  {
    Header: 'Industry',
    accessor: 'DET_INDUSTRY',
    className: columnClassName,
  },
  {
    Header: 'Territory',
    accessor: 'DET_TERRITORY',
    className: columnClassName,
  },
  {
    Header: 'Location',
    accessor: 'DET_LOCATION',
    className: columnClassName,
  },
  {
    Header: 'Email',
    accessor: 'NUM_EMAILADDRESS',
    className: columnClassName,
  },
  {
    Header: 'Website',
    accessor: 'Web_Site',
    className: columnClassName,
  },
  {
    Header: 'Referral Source',
    accessor: 'Referral_Source',
    className: columnClassName,
  },
  {
    Header: 'Date Entered',
    accessor: 'Date_Entered',
    className: columnClassName,
  },
  {
    Header: 'Date Last Updated',
    accessor: 'Date_LastUpdated',
    className: columnClassName,
  },
  {
    Header: 'AMC',
    accessor: 'AMC',
    className: columnClassName,
  },
];

function getSortedIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const ClientSearchTable = ({ data, loading }) => {
  const tableInstance = useTable(
    {
      columns: casColumns,
      data,
      initialState: {
        pageSize: 200,
        sortBy: [
          {
            id: 'CreatedAt',
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => (
      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
        {column.render('Header')}
        <span>
          {column.canSort
            ? getSortedIcon(column.isSorted, column.isSortedDesc)
            : null}
        </span>
      </th>
    ));
    return <tr {...headerGroup.getHeaderGroupProps()}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => (
      <td
        {...cell.getCellProps({
          className: cell.column.className,
          style: cell.column.style,
        })}
      >
        {cell.render('Cell')}
      </td>
    ));

    return <tr {...row.getRowProps()}>{cells}</tr>;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col className="d-flex justify-content-center justify-content-md-end">
          <TablePagination tableInstance={tableInstance} />
        </Col>
      </Row>
      <Row>
        <Col className="border border-light rounded shadow-sm">
          <Table hover responsive borderless {...getTableProps()}>
            <thead className="text-nowrap">{tableHeaders}</thead>
            <tbody {...getTableBodyProps()}>{tableRows}</tbody>
          </Table>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading && <Spinner animation="border" />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ClientSearchTable;
